import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, useCallback } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

var useFieldForm = function useFieldForm() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    fields = _useState2[0],
    setFields = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var validators = useRef({}).current;
  var register = useCallback(function (name, option) {
    validators[name] = option === null || option === void 0 ? void 0 : option.validate;
    setFields(function (prevFields) {
      return _objectSpread2(_objectSpread2({}, prevFields), {}, _defineProperty({}, name, option === null || option === void 0 ? void 0 : option.defaultValue));
    });
  }, [fields, validators]);
  var onChange = useCallback(function (name, value) {
    setFields(function (prevFields) {
      return _objectSpread2(_objectSpread2({}, prevFields), {}, _defineProperty({}, name, value));
    });
  }, [fields, validators]);
  var trigger = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name) {
      var _validators$name, _value, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!validators[name]) {
              _context.next = 7;
              break;
            }
            _value = fields[name];
            _context.next = 4;
            return (_validators$name = validators[name]) === null || _validators$name === void 0 ? void 0 : _validators$name.call(validators, _value);
          case 4:
            error = _context.sent;
            setErrors(function (prevErrors) {
              return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, name, error));
            });
            return _context.abrupt("return", error);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [fields, validators]);
  var setValue = useCallback(function (name, value) {
    setFields(function (prevFields) {
      return _objectSpread2(_objectSpread2({}, prevFields), {}, _defineProperty({}, name, value));
    });
    trigger(name);
  }, [trigger]);
  var setError = useCallback(function (name, error) {
    setErrors(function (prevErrors) {
      return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, name, error));
    });
  }, []);
  return {
    fields: fields,
    errors: errors,
    register: register,
    onChange: onChange,
    trigger: trigger,
    setValue: setValue,
    setError: setError
  };
};

export { useFieldForm };
//# sourceMappingURL=useFieldForm.js.map
